import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterOutlet, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Header } from '../../../components/shared/header/header';
import { LeadContextService } from '../../../services/lead-context.service';

@Component({
  selector: 'app-leads-navigation',
  standalone: true,
  imports: [CommonModule, Header, RouterOutlet],
  templateUrl: './leads-navigation.html',
  styleUrls: ['./leads-navigation.scss'],
})
export class LeadsNavigation implements OnInit, OnDestroy {
  currentPage = 0;
  totalPages = 3;
  breadcrumbLabel = 'Leads';
  leadId: string | null = null;
  hasNavigationBar: boolean = true;
  private contextSubscription?: Subscription;

  private pageRoutes = ['/leads/leads-info', '/leads/leads-offers', '/leads/leads-history'];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private leadContextService: LeadContextService,
  ) {}

  ngOnInit() {
    // Capturar leadId da rota
    this.route.firstChild?.params.subscribe((params) => {
      this.leadId = params['leadId'] || null;
    });

    // Atualizar breadcrumb quando cdSiglaTipo mudar
    this.contextSubscription = this.leadContextService.cdSiglaTipo$.subscribe((tipo) => {
      this.breadcrumbLabel = this.leadContextService.getBreadcrumbLabel();
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateCurrentPage(event.url);
      });

    this.updateCurrentPage(this.router.url);

    this.leadContextService.hasNavigationBar.subscribe((flag: boolean) => {
      this.hasNavigationBar = flag;
    });

    // Inicializar breadcrumb
    this.breadcrumbLabel = this.leadContextService.getBreadcrumbLabel();
  }

  ngOnDestroy() {
    if (this.contextSubscription) {
      this.contextSubscription.unsubscribe();
    }
  }

  updateCurrentPage(url: string) {
    if (url.includes('detalhes') || url.includes('leads-info')) this.currentPage = 0;
    else if (url.includes('leads-offers')) this.currentPage = 1;
    else if (url.includes('leads-history')) this.currentPage = 2;
  }

  nextPage() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.navigateToPage(this.currentPage);
    }
  }

  previousPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.navigateToPage(this.currentPage);
    }
  }

  navigateToPage(page: number) {
    if (this.leadId) {
      // Usar rota com leadId
      const routesWithId = [
        `/leads/${this.leadId}/detalhes`,
        `/leads/${this.leadId}/leads-offers`,
        `/leads/${this.leadId}/leads-history`,
      ];
      this.router.navigate([routesWithId[page]]);
    } else {
      // Fallback para rotas antigas
      this.router.navigate([this.pageRoutes[page]]);
    }
  }

  navigateToHome() {
    this.router.navigate(['/dashboard']);
  }

  // NOVO MÉTODO: Navegação baseada no tipo do lead
  navigateByBreadcrumb() {
    const tipo = this.leadContextService.getCdSiglaTipo();
    const tipoUpper = tipo?.toUpperCase() || '';

    // Verificar se é PR (pode ser "PR" ou "CAPR000001" ou similar)
    const isPR = tipoUpper === 'PR' || tipoUpper.startsWith('CAPR') || tipoUpper.includes('PR');

    if (isPR) {
      this.router.navigate(['/rebuying']);
    } else if (tipoUpper === 'PA') {
      this.router.navigate(['/approved-proposals']);
    } else if (tipoUpper === 'SO') {
      this.router.navigate(['/simulations']);
    } else if (tipoUpper === 'SS') {
      this.router.navigate(['/sign-drive']);
    } else if (tipoUpper === 'SP') {
      this.router.navigate(['/subscription-renew']);
    } else {
      // Fallback para home se não for nenhum dos tipos especificados
      this.navigateToHome();
    }
  }
}
